const _import = require('../import-' + process.env.NODE_ENV)

const priceTagRouter = [
  {
    path: '/priceTag/index',
    name: 'priceTagIndex',
    component: _import('priceTag/index'),
    meta: {
      title: '价签打印',
      auth: true
    }
  }
]
export default priceTagRouter



// WEBPACK FOOTER //
// ./src/router/work/priceTag.js